export default "__VITE_ASSET__RRuzaaEC__"